import { render, staticRenderFns } from "./LiveSelectionRecord.vue?vue&type=template&id=1cbc9e36&scoped=true"
import script from "./LiveSelectionRecord.vue?vue&type=script&lang=js"
export * from "./LiveSelectionRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbc9e36",
  null
  
)

export default component.exports